<template lang="pug">
p(:class="computedClasses")
  slot
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type ParagraphProps } from './Paragraph.types';
import { paragraphDefaults } from './Paragraph.defaults';

const props = withDefaults(defineProps<ParagraphProps>(), paragraphDefaults);

const computedClasses = computed(() => {
  return [
    props.size !== 'none' ? `fs-${props.size}` : '',
    `fw-${props.fontWeight}`,
    props.context !== 'none' ? `text-${props.context}` : '',
  ].filter(Boolean);
});
</script>
